import { CornerSquareTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  extraRounded: "extra-rounded",
  hexagon: "hexagon",
  octagon: "octagon",
  leaf: "leaf"
} as CornerSquareTypes;
